
import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'MaintenanceDueDateDialog',
  props: {
    request: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      menu: false,
      selectedDueDate: '' as string,
      loading: false,
      minDate: moment().format('YYYY-MM-DD')
    };
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    formattedDueDate() {
 
      const date = this.request?.estimatedCompletionDate;
      if (!date) return '';
      return moment(date).format(this.facility.dateFormat || 'DD/MM/YYYY');
    }
  },
  watch: {
    'request.estimatedCompletionDate': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.selectedDueDate = newVal;
        } else {
          this.selectedDueDate = moment().format('YYYY-MM-DD');
        }
      }
    }
  },
  methods: {
    cancel() {
      this.menu = false;
      if (this.request?.estimatedCompletionDate) {
        this.selectedDueDate = this.request.estimatedCompletionDate;
      }
    },
    async saveDueDate() {
      if (!this.selectedDueDate || !this.request) return;
      
      this.loading = true;
      try {
        await this.$store.dispatch('editMaintenanceRequest', {
          id: this.request.id,
          updates: {
            estimatedCompletionDate: this.selectedDueDate
          }
        });
        
        if (this.request) {
          this.$set(this.request, 'estimatedCompletionDate', this.selectedDueDate);
        }
        
        this.$toast.open({
          type: 'success',
          message: this.$t('Maintenance due date updated successfully')
        });
        
        this.$emit('updated');
        this.menu = false;
      } catch (error) {
        console.error('Error updating due date:', error);
        this.$toast.open({
          type: 'error',
          message: this.$t('Error updating due date')
        });
      } finally {
        this.loading = false;
      }
    }
  }
});
